// import $ from "jquery";
// window.jQuery = $;
// window.$ = $;
// global.jQuery = $;
const scroll = require("./modules/scroll.js");